const SELECTORS = {
  PRODUCT_LIST: '.content-for-layout .product-grid'
}

const BUTTONS = [
  `<a class="promo-card__button promo-card__button--0">Shop Now</a>`,
  `<a class="promo-card__button promo-card__button--1">Shop Now</a>`,
  `<a class="promo-card__button promo-card__button--2">Subscribe Now</a>`,
]

const URLS = {
  SALE: '/pages/sale',
  ARM_CREAM: '/products/sculpt-tone-arm-cream',
  GIFT_BOX: '/products/the-glow-essentials-gift-set',
  NECK_CREAM: '/products/tighten-lift-neck-cream-1',
  ANTI_WRINKLE: '/products/gopure-anti-wrinkle-moisturizer',
  BUTT_THIGH: '/products/butt-thigh-cream',
  BODY_SCRUB: '/products/refine-renew-body-scrub',
  BUTT_THIGH_BODY_SCRUB: '/products/butt-thigh-cream-body-scrub',
  SUMMER_SALE: '/collections/summer-sale'
}

const TYPES = {
  BFCM: 'BFCM',
  ARM_CREAM: 'ARM_CREAM',
  ARM_CREAM_2: 'ARM_CREAM_2',
  SUB_AND_SAVE: 'SUB_AND_SAVE',
  NECK_CREAM: 'NECK_CREAM',
  NECK_CREAM_2: 'NECK_CREAM_2',
  NECK_CREAM_3: 'NECK_CREAM_3',
  GIFT_BOX: 'GIFT_BOX',
  ANTI_WRINKLE: 'ANTI_WRINKLE',
  BUTT_THIGH: 'BUTT_THIGH',
  BUTT_THIGH_2: 'BUTT_THIGH_2',
  BODY_SCRUB: 'BODY_SCRUB',
  BODY_SCRUB_2: 'BODY_SCRUB_2',
  SUMMER_SALE: 'SUMMER_SALE',
  SUMMER_SALE_2: 'SUMMER_SALE_2',
  SUMMER_SALE_3: 'SUMMER_SALE_3',
  SUMMER_SALE_4: 'SUMMER_SALE_4'
}

const IMAGES = {
  [TYPES.BFCM]: {
    MOBILE: 'https://cdn.shopify.com/s/files/1/0743/0383/files/BFCM-V2-mob.jpg?v=1731451919',
    DESKTOP: 'https://cdn.shopify.com/s/files/1/0743/0383/files/BFCM-V2-desk.jpg?v=1731451920'
  },
  [TYPES.ARM_CREAM]: {
    MOBILE: 'https://cdn.shopify.com/s/files/1/0743/0383/files/S_S-V2-mob.jpg?v=1733939757',
    DESKTOP: 'https://cdn.shopify.com/s/files/1/0743/0383/files/S_S-V2-desk.jpg?v=1733939758'
  },
  [TYPES.ARM_CREAM_2]: {
    MOBILE: 'https://cdn.shopify.com/s/files/1/0743/0383/files/AC-V1-mob.jpg?v=1733940438',
    DESKTOP: 'https://cdn.shopify.com/s/files/1/0743/0383/files/AC-V1-desk.jpg?v=1733940438'
  },
  [TYPES.SUB_AND_SAVE]: {
    MOBILE: 'https://cdn.shopify.com/s/files/1/0743/0383/files/S_S-V2-mobwhite_c7f29e6c-38f0-463d-8618-beba174fdf95.jpg?v=1731520763',
    DESKTOP: 'https://cdn.shopify.com/s/files/1/0743/0383/files/S_S-V2-deskwhite_5b7d7e20-858d-4d06-8577-36f6540ea153.jpg?v=1731520763'
  },
  [TYPES.NECK_CREAM]: {
    MOBILE: 'https://cdn.shopify.com/s/files/1/0743/0383/files/NC-V2-mob_2c366fc0-dc80-4e3e-a206-50f6ede43011.jpg?v=1733939758',
    DESKTOP: 'https://cdn.shopify.com/s/files/1/0743/0383/files/NC-V2-desk_3a32dedf-d6dc-423f-be82-74b17fd02846.jpg?v=1733939758'
  },
  [TYPES.NECK_CREAM_2]: {
    MOBILE: 'https://cdn.shopify.com/s/files/1/0743/0383/files/S_S-V3-mob.jpg?v=1733940800',
    DESKTOP: 'https://cdn.shopify.com/s/files/1/0743/0383/files/S_S-V3-desk.jpg?v=1733940800'
  },
  [TYPES.NECK_CREAM_3]: {
    MOBILE: 'https://cdn.shopify.com/s/files/1/0743/0383/files/NC-V1-mob.jpg?v=1733941144',
    DESKTOP: 'https://cdn.shopify.com/s/files/1/0743/0383/files/NC-V1-desk.jpg?v=1733941144'
  },
  [TYPES.GIFT_BOX]: {
    MOBILE: 'https://cdn.shopify.com/s/files/1/0743/0383/files/MINIS-V1-mobBFCM.jpg?v=1732569535',
    DESKTOP: 'https://cdn.shopify.com/s/files/1/0743/0383/files/MINIS-V1-deskBFCM.jpg?v=1732569535'
  },
  [TYPES.ANTI_WRINKLE]: {
    MOBILE: 'https://cdn.shopify.com/s/files/1/0743/0383/files/S_S-V1-mob.jpg?v=1733941418',
    DESKTOP: 'https://cdn.shopify.com/s/files/1/0743/0383/files/S_S-V1-desk.jpg?v=1733941418'
  },
  [TYPES.BUTT_THIGH]: {
    MOBILE: 'https://cdn.shopify.com/s/files/1/0743/0383/files/BT-1-mob.jpg?v=1744755227',
    DESKTOP: 'https://cdn.shopify.com/s/files/1/0743/0383/files/BT-1-desk_09870f32-3f51-4ba3-bb92-b7e7f3585e3d.jpg?v=1744909144'
  },
  [TYPES.BUTT_THIGH_2]: {
    MOBILE: 'https://cdn.shopify.com/s/files/1/0743/0383/files/BT-3-mob.jpg?v=1744755925',
    DESKTOP: 'https://cdn.shopify.com/s/files/1/0743/0383/files/BT-3-desk_30bfb5fd-a0b0-4910-a3cd-037f0faf3d44.jpg?v=1744909144'
  },
  [TYPES.BODY_SCRUB]: {
    MOBILE: 'https://cdn.shopify.com/s/files/1/0743/0383/files/SCRUB-1-mob.jpg?v=1744755930',
    DESKTOP: 'https://cdn.shopify.com/s/files/1/0743/0383/files/SCRUB-1-desk_4ea8c45d-b772-42c4-8d17-2c0e89c20f97.jpg?v=1744909144'
  },
  [TYPES.BODY_SCRUB_2]: {
    MOBILE: 'https://cdn.shopify.com/s/files/1/0743/0383/files/BT_SCRUB-mob.jpg?v=1744754860',
    DESKTOP: 'https://cdn.shopify.com/s/files/1/0743/0383/files/BT_SCRUB-desk_6e9edeb2-388c-4b48-8582-bf35394b4d4a.jpg?v=1744909144'
  },
  [TYPES.SUMMER_SALE]: {
    MOBILE: 'https://cdn.shopify.com/s/files/1/0743/0383/files/ss-promo-card-01-mobile.jpg?v=1747318763',
    DESKTOP: 'https://cdn.shopify.com/s/files/1/0743/0383/files/ss-promo-card-01-desktop.jpg?v=1747318763'
  },
  [TYPES.SUMMER_SALE_2]: {
    MOBILE: 'https://cdn.shopify.com/s/files/1/0743/0383/files/ss-promo-card-02-mobile.jpg?v=1747318763',
    DESKTOP: 'https://cdn.shopify.com/s/files/1/0743/0383/files/ss-promo-card-02-desktop.jpg?v=1747318763'
  },
  [TYPES.SUMMER_SALE_3]: {
    MOBILE: 'https://cdn.shopify.com/s/files/1/0743/0383/files/ss-promo-card-03-mobile.jpg?v=1747318763',
    DESKTOP: 'https://cdn.shopify.com/s/files/1/0743/0383/files/ss-promo-card-03-desktop.jpg?v=1747318763'
  },
  [TYPES.SUMMER_SALE_4]: {
    MOBILE: 'https://cdn.shopify.com/s/files/1/0743/0383/files/ss-promo-card-04-mobile.jpg?v=1747318763',
    DESKTOP: 'https://cdn.shopify.com/s/files/1/0743/0383/files/ss-promo-card-04-desktop.jpg?v=1747318763'
  },
}

const collectionData = {
  ['all']: [
    {
      type: TYPES.SUMMER_SALE_4,
      position: {
        mobile: 2,
        desktop: 2
      },
      image: IMAGES.SUMMER_SALE_4,
      button: null,
      url: URLS.SUMMER_SALE
    },
    {
      type: TYPES.SUMMER_SALE_2,
      position: {
        mobile: 10,
        desktop: 8
      },
      image: IMAGES.SUMMER_SALE_2,
      button: null,
      url: URLS.SUMMER_SALE
    }
  ],
  ['best-sellers']: [
    {
      type: TYPES.SUMMER_SALE_4,
      position: {
        mobile: 2,
        desktop: 2
      },
      image: IMAGES.SUMMER_SALE_4,
      button: null,
      url: URLS.SUMMER_SALE
    },
    {
      type: TYPES.SUMMER_SALE,
      position: {
        mobile: 9,
        desktop: 9
      },
      image: IMAGES.SUMMER_SALE,
      button: null,
      url: URLS.SUMMER_SALE
    }
  ],
  ['moisturizers']: [
    {
      type: TYPES.SUMMER_SALE_2,
      position: {
        mobile: 2,
        desktop: 2
      },
      image: IMAGES.SUMMER_SALE_2,
      button: null,
      url: URLS.SUMMER_SALE
    }
  ],
  ['whats-new']: [
    {
      type: TYPES.SUMMER_SALE_2,
      position: {
        mobile: 2,
        desktop: 2
      },
      image: IMAGES.SUMMER_SALE_2,
      button: null,
      url: URLS.SUMMER_SALE
    },
    {
      type: TYPES.SUMMER_SALE,
      position: {
        mobile: 9,
        desktop: 9
      },
      image: IMAGES.SUMMER_SALE,
      button: null,
      url: URLS.SUMMER_SALE
    }
  ],
  ['bundlesavings']: [
    {
      type: TYPES.SUMMER_SALE_2,
      position: {
        mobile: 2,
        desktop: 2
      },
      image: IMAGES.SUMMER_SALE_2,
      button: null,
      url: URLS.SUMMER_SALE
    }
  ],
  ['body-care']: [
    {
      type: TYPES.SUMMER_SALE,
      position: {
        mobile: 2,
        desktop: 2
      },
      image: IMAGES.SUMMER_SALE,
      button: null,
      url: URLS.SUMMER_SALE
    }
  ]
}

const LOCATIONS = {
  US: 'US', // United States
  CA: 'CA', // Canada
  AU: 'AU', // Australia
  NZ: 'NZ', // New Zealand
  GB: 'GB', // United Kingdom
}

const blacklist = {
  locations: [LOCATIONS.AU, LOCATIONS.NZ, LOCATIONS.GB],
  types: [
    TYPES.ARM_CREAM_2,
    TYPES.NECK_CREAM_3,
    TYPES.NECK_CREAM
  ]
}

const createCard = (data) => {
  const newEl = document.createElement('li')
  newEl.dataset.type = data.type
  newEl.className = `promo-card grid__item tracking-${data.type}`
  newEl.innerHTML = `
    <div class="promo-card__images">
      <img src="${data.image.MOBILE}" class="promo-card__image--mobile">
      <img src="${data.image.DESKTOP}" class="promo-card__image--desktop">
    </div>
    ${data.button ? `<div class="promo-card__content">${data.button}</div>` : ''}
    <a href="${data.url}" class="promo-card__link"></a> 
  `
  newEl.addEventListener('click', (event) => {
    if (!mixpanel?.track) return
    event.preventDefault()
    mixpanel.track("Image Banner Clicked", {
      "page_url": window.location.href,          
      "page_title": document.title,              
      "page_path": window.location.pathname       
    })
    window.location.href = data.url
  })
  return newEl
}

const init = () => {
  const isMobile = window.innerWidth < 990
  const { pathname } = window.location
  const pageValue = Object.fromEntries(
    (new URLSearchParams(window.location.search)).entries()
  ).page
  const collectionUrl = window.location.pathname.split('/')[2]

  // Only show promo cards on the first page of collections.
  if (
    !pathname.includes('/collections/') ||
    pageValue >= 2
  ) return
  
  const productListEl = document.querySelector(SELECTORS.PRODUCT_LIST)
  const promoCards = collectionData[collectionUrl]

  
  const location = document.querySelector('body').dataset.location
  const positions = promoCards.map((data) => data.position)
  let positionIndex = 0

  promoCards.forEach((data) => {
    // Hide promo cards for some countries.
    if (blacklist.locations.includes(location) && !blacklist.types.includes(data.type)) return
    // Maintain the order of the promo cards, accounting for skips in positions.
    const position = isMobile ? positions[positionIndex].mobile : positions[positionIndex].desktop
    productListEl.insertBefore(
      createCard(data),
      productListEl.children[position]
    )
    positionIndex++
  })

}

init()